import React from "react";
import Introduction from "./Partials/Introduction";
import Icon from "./Support/Icon";

export default function ResultFooterFree() {
    const price = "ab 14,90 EUR / Monat";
    const learnMoreLink = "https://www.e-recht24.de/e24link/z1cbl";

    function buttonAction() {
        window.open("https://www.e-recht24.de/e24link/bw3h2","_self")
    }

    return (
        <div className='grid grid-cols-1 md:grid-cols-12 gap-8 w-full py-8'>
            <div className='md:col-span-3 lg:col-span-2'>
                <Icon
                    type='gradient-arrow'
                    css='h-20 w-20 md:h-32 md:w-32 m-auto transform rotate-90 md:rotate-0'
                />
            </div>
            <div className='md:col-span-9 lg:col-span-10 text-center md:text-left'>
                <Introduction
                    prefix={'Handlungsempfehlung'}
                    headline={'Machen Sie Ihre Website jetzt datenschutzkonform.'}
                    suffix='eRecht24 Premium begleitet Sie auf dem Weg zur datenschutzkonformen Website. Sichern Sie sich ganz ohne teuren Anwalt gegen drohende Bußgelder und Abmahnungen ab.'
                />

                <div className='flex sm:flex-row flex-col items-center sm:items-start justify-center md:justify-start space-x-4 mt-8'>
                    <div>
                        <button
                            onClick={buttonAction}
                            className='button rounded-sm'
                        >
                            Jetzt Website absichern
                        </button>
                        <p className='pt-4 text-center sm:hidden'>
                            <strong>
                                { price }
                            </strong>
                        </p>
                        <small className='block text-center mt-3'>
                            <a
                                href={learnMoreLink}
                                target='_blank'
                                className='underline hover:no-underline cursor-pointer'
                            >
                                mehr über eRecht24 Premium erfahren
                            </a>
                        </small>
                    </div>
                    <p className='pt-4 text-left hidden sm:block'>
                        <strong>
                            { price }
                        </strong>
                    </p>
                </div>
            </div>
        </div>
    )
}
